import {forwardRef} from "react";
import {useGetCurrentWorkspaceId} from "@tinct/core-workspace";
import {LayoutHeader} from "@tinct/web-layout";
import {UpdateVisualIdentityForm} from "../../../forms/update-visual-identity-form";
import {useFunnel} from "@tinct/web-funnel";

export const Step5VisualIdentity = forwardRef<HTMLFormElement, object>((_, ref) => {
  const workspaceId = useGetCurrentWorkspaceId();
  const { navigateToNextStep } = useFunnel();

  return (
    <div className="container max-w-4xl mx-auto gap-8 flex flex-col py-8">
      <LayoutHeader
        pageTitle="Brand Guidelines"
        pageDescription="Visual Identity"
      />
      <UpdateVisualIdentityForm ref={ref} organizationId={workspaceId} onSuccess={navigateToNextStep} hideFooter />
    </div>
  );
});

Step5VisualIdentity.displayName = 'Step5VisualIdentity';
